// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"35":"player","177":"home","182":"end","209":"pre","585":"waiting","631":"service","685":"register"}[chunkId] + "." + {"35":"c7f1e93f","177":"6606ceb1","182":"da887e2f","209":"e55fd8cb","585":"65e607bc","631":"94b1c0ad","685":"12d4de9b"}[chunkId] + ".css";
};